
// client errors on parent signup form
export const CLIENT_ERRORS = {
  refreshPageError: 'Signup failed. Please reload the page or contact support.',
};
